import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const poItemPatchSlice = createApi({
    reducerPath: "poItemPatch",
    baseQuery: fetchBaseQuery({
        baseUrl: "https://brand-logistics.demo.permute.in",
        prepareHeaders: (headers, { getState }) => {
            const token = localStorage.getItem("authToken");
            if (token) {
                headers.set("authorization", "Bearer " + token);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        poItemPatch: builder.mutation({
            query: ({ id, data }) => ({ url: "/inventory/api/v1/poitem/update?id=" + id, method: "PATCH", body: data }),
        }),
    }),
});

export const { usePoItemPatchMutation } = poItemPatchSlice;
